
const Loader = () => {
  return (
    <div className='flex justify-center items-center align-middle h-screen'>
        <span className="loader lg:w-20 md:w-14 sm:w-8 "></span>
    </div>
  )
}

export default Loader;